import { useContext } from "react";
import { ChoseDepartmentContext, type ChosenDepartmentCtxValues } from "./context";

export function useChosenDepartment(): ChosenDepartmentCtxValues {
	const ctxValue = useContext(ChoseDepartmentContext);
	if (!ctxValue) {
		throw Error("Please make sure that you call this hook under the `ChosenDepartmentProvider`");
	}

	return ctxValue;
}
